import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { RootState } from '@/app/providers/store';

interface PlanStore {
  selectedPlanType: string;
  planType: string;
}

const DEFAULT_PLAN_TYPE = 'Pro';

const initialState: PlanStore = {
  selectedPlanType: '',
  planType: DEFAULT_PLAN_TYPE,
};

const planSlice = createSlice({
  name: 'plan',
  initialState,
  reducers: {
    setSelectedPlanType: (state, action: PayloadAction<string>) => {
      state.selectedPlanType = action.payload;
    },
    setPlanType: (state, action: PayloadAction<string>) => {
      state.planType = action.payload;
    },
    resetPlan: (state) => {
      state.selectedPlanType = '';
      state.planType = DEFAULT_PLAN_TYPE;
    },
    resetPlanType: (state) => {
      state.planType = DEFAULT_PLAN_TYPE;
    },
  },
});

export const { setSelectedPlanType, setPlanType, resetPlan, resetPlanType } =
  planSlice.actions;

export const selectPlan = (state: RootState): PlanStore => state.plan;
export const selectPlanType = (state: RootState): string => state.plan.planType;
export const selectSelectedPlanType = (state: RootState): string =>
  state.plan.selectedPlanType;

export const planReducer = planSlice.reducer;
